module.exports = __webpack_public_path__ + "img/video_poster.45ada98f.jpeg";